<template>
  <ODialog ref="dialog" :maxWidth="600" hideWhenLoading>
    <v-card v-if="row != null">
      <ODialogBar title="Editar Rede" :subtitle="row.id" @close="dismiss" />
      <v-card-text class="pa-3">
        <v-form ref="theForm" v-model="isValid">
          <div class="w-full d-flex">
            <OTextField
              class="w-1/3 pa-3"
              label="Nome"
              v-model="row.name"
              :rules="[isSet]"
            />

            <OTextField class="w-1/3 pa-3" label="SSID" v-model="row.ssid" />

            <OTextField class="w-1/3 pa-3" label="Senha" v-model="row.pass" />
          </div>
          <div class="pa-3">
            <OTagsInput v-model="row.tags" :items="allTags" label="Tags" />
          </div>
          <div class="pa-3">
            <OTextarea
              class="w-full"
              label="Observações"
              v-model="row.comments"
              hint="(Máximo de 250 caracteres)"
            />
          </div>
          <div class="w-full d-flex">
            <OTextField
              class="w-1/3 pa-3"
              label="Recebido de"
              v-model="row.receivedFrom"
              hide-details
            />
            <OTextField
              class="w-1/3 pa-3"
              label="Recebido por"
              v-model="row.receivedBy"
              hide-details
            />

            <ODateInput
              class="w-1/3 pa-3"
              label="Recebido em"
              v-model="row.receivedAt"
            />
          </div>
        </v-form>
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        @cancel="dismiss"
        @apply="apply"
        txtApply="Salvar"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { WifiNetwork } from '@/models'
import OTagsInput from 'oderon-vue/cpts/OTagsInput.vue'
import ODateInput from 'oderon-vue/cpts/ODateInput.vue'
import { isSet } from 'oderon-vue/utils.js'

export default {
  components: { ODateInput, OTagsInput },
  data() {
    return {
      id: null,
      row: null,
      allTags: [],
      isValid: false,
      isSet
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open(id)
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    async fetchData() {
      let cloud = await WifiNetwork.findTagCloud()
      this.allTags = cloud.map((x) => x.code)
      this.row = await WifiNetwork.findById(this.id)
    },
    apply() {
      this.$refs.theForm.validate()
      if (this.isValid) {
        this.$refs.dialog.$loading(async () => {
          await WifiNetwork.patch(this.id, this.row)
          this.$snack('Salvo com sucesso')
          this.$refs.dialog.$apply(true) // reload na tela de baixo
        })
      }
    }
  }
}
</script>

<style></style>
